export interface TrustBarItem {
  icon: string;
  label: string;
}

export interface PageTrustBarProps {
  items: TrustBarItem[];
}

export default function PageTrustBar({ items }: PageTrustBarProps) {
  return (
    <section className="bg-inkblack border-b border-white/8 py-5">
      <div className="max-w-screen-xl mx-auto px-8 lg:px-12">
        <div className="flex flex-wrap items-center justify-center gap-0 divide-x divide-white/10">
          {items.map((item, i) => (
            <div key={i} className="inline-flex items-center gap-3 px-6 lg:px-8 py-1">
              <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-antique text-sm`} />
              </div>
              <span className="text-white/50 text-xs font-sans font-500 tracking-[0.18em] uppercase whitespace-nowrap">
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
